@if (show) {
<div
  class="w-full bg-primary-500 text-white flex items-center justify-between gap-3 px-4 py-2.5 z-50 relative"
>
  <div class="flex items-center gap-3 min-w-0">
    <img
      src="assets/brand/atc-72x72.png"
      alt="AtChurch"
      class="h-9 w-9 rounded-lg flex-shrink-0"
    />
    <div class="min-w-0">
      <p class="text-sm font-semibold leading-tight truncate">
        Open in the AtChurch App
      </p>
      <p class="text-xs text-white/70 leading-tight truncate">
        Faster join, notifications &amp; more
      </p>
    </div>
  </div>

  <div class="flex items-center gap-2 flex-shrink-0">
    <button
      type="button"
      (click)="openApp()"
      class="rounded-full text-xs font-semibold px-4 py-1.5 bg-secondary-500 text-white hover:bg-secondary-600"
    >
      Open
    </button>
    <button
      type="button"
      (click)="dismiss()"
      aria-label="Dismiss"
      class="text-white/70 hover:text-white px-1"
    >
      <i class="fa fa-xmark"></i>
    </button>
  </div>
</div>
}
